import { PayloadAction } from '@reduxjs/toolkit';
import { FormatState } from 'src/store/format/types';

const setAvailableFormatsAreLoadingReducer = (state: FormatState, action: PayloadAction<boolean>) => {
  state.availableFormatsAreLoading = action.payload;
};

export default setAvailableFormatsAreLoadingReducer;
